import React,{useState} from 'react'
import Header from './Header'
import {Submit} from '../Logic/index01'
import Swal from 'sweetalert2';
import Footer from './Footer';

const Contact = () =>{

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")



  const MapIn = async () => {
    if(
       name.trim().length > 0 && email.trim().length > 0 
       && phone.trim().length > 0  &&  subject.trim().length > 0 
       && message.trim().length > 0 
      ){
     await Submit(name,email,phone,subject,message);
     Swal.fire({
            title: "Received.",
            icon:"success",
            showClass: {
              popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `
            },
            hideClass: {
              popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `
            }
        });
          setName("");
            setEmail(""); 
             setPhone(""); 
              setSubject("")
               setMessage("")
  }else{
        Swal.fire({
          icon: "error",
          title: "Error...",
          text: "All fields are mandatory!",
          footer: '<a href="#">Having issue?</a>'
        });
  }

  }

  return (
    <>
        <Header/>
        <div class="bg-white flex flex-col min-h-screen">
           <main class="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
            <div class="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start mt-12">
                <div class="space-y-8"><div>
                <h2 class="text-3xl lg:text-4xl font-extrabold tracking-tight ">Get in Touch</h2>
                <p class="mt-4 text-lg text-subtle-light dark:text-subtle-dark">
                  We're here to help. Please fill out the form below, or reach out to us directly using the contact information provided.
                </p>
            </div>
            <div class="space-y-6 bg-background-light p-10 rounded-lg shadow-md">
                        <div>
                        <label class="block text-sm font-medium mb-2" for="name">Your Name</label>
                        <input onChange={(e) => setName(e.target.value)} value={name}  class="w-full h-12 px-4 rounded-lg bg-white border border-indigo-200 focus:ring-1 focus:ring-primary focus:border-primary transition-shadow" id="name" name="name" placeholder="Enter your name" type="text"/>
                        </div>
                        <div>
                        <label  class="block text-sm font-medium mb-2" for="email">Email Address</label>
                        <input onChange={(e) => setEmail(e.target.value)} value={email}  class="w-full h-12 px-4 rounded-lg bg-white border border-indigo-200  focus:ring-2 focus:ring-primary focus:border-primary transition-shadow" id="email" name="email" placeholder="Enter your email" type="email"/>
                        </div>
                        <div>
                        <label class="block text-sm font-medium mb-2" for="phone">Phone Number</label>
                        <input onChange={(e) => setPhone(e.target.value)} value={phone}  class="w-full h-12 px-4 rounded-lg bg-white border border-indigo-200  focus:ring-2 focus:ring-primary focus:border-primary transition-shadow" id="phone" name="phone" placeholder="Enter your phone number" type="tel"/>
                        </div>
                        <div>
                        <label class="block text-sm font-medium mb-2" for="subject">Subject</label>
                        <input onChange={(e) => setSubject(e.target.value)} value={subject}  class="w-full h-12 px-4 rounded-lg bg-white border border-indigo-200  focus:ring-2 focus:ring-primary focus:border-primary transition-shadow" id="subject" name="subject" placeholder="Enter the subject" type="text"/>
                        </div>
                          <div>
                              <label class="block text-sm font-medium mb-2" for="message">Message</label>
                              <textarea onChange={(e) => setMessage(e.target.value)} value={message}  class="w-full p-4 rounded-lg bg-white border border-indigo-200  focus:ring-2 focus:ring-primary focus:border-primary transition-shadow" id="message" name="message" placeholder="Enter your message" rows="5"></textarea>
                          </div>
                        <div>
                    <button onClick={(e) => MapIn()} class="w-full flex items-center justify-center rounded-lg h-12 px-6 text-base font-bold bg-primary text-blue-400 hover:bg-opacity-90 transition-colors" type="submit">
                        Send Message
                    </button>
                  </div>
                </div>
          </div>
              <div class="space-y-8">
                <div><h3 class="text-2xl font-bold">Contact Information</h3>
              <div class="mt-6 space-y-4 text-subtle-light dark:text-subtle-dark">
              <p class="flex items-start">
              <span class="material-symbols-outlined text-primary mr-3 mt-1">call</span>
              <span class="text-content-light dark:text-content-dark">+234 916 338 5136</span>
              </p>
              <p class="flex items-start">
              <span class="material-symbols-outlined text-primary mr-3 mt-1">mail</span>
              <span class="text-content-light dark:text-content-dark">info@beeppee.com</span>
              </p>
              <p class="flex items-start">
              <span class="material-symbols-outlined text-primary mr-3 mt-1">location_on</span>
              <span class="text-content-light dark:text-content-dark">festac town Lagos</span>
              </p>
              </div>
              </div>
              <div>
              <h3 class="text-2xl font-bold">Office Location</h3>
              <div class="mt-6 aspect-w-16 aspect-h-9 rounded-lg overflow-hidden border border-border-light dark:border-border-dark">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.4390483737716!2d3.2740112704173314!3d6.465931979216909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b88c0a859e9f1%3A0x817c7d671212e50d!2s31%205th%20Avenue%2C%20I%20Cl%2C%20Festac%20Town%2C%20Lagos%20102102%2C%20Lagos!5e0!3m2!1sen!2sng!4v1766691715476!5m2!1sen!2sng" width="100%" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>
              </div>
              </div>
              </div>
              </div>
          </main>
        </div>
      <Footer/>
    </>
  )
}

export default Contact
